import React from 'react';
import { IntlShape } from 'react-intl';
import * as IoC from 'typescript-ioc';
import { IMeetingDetailsDTO } from '../../../../../../api/meetings.dao';
import { ISortOptions, ITheadSort, ListLayout } from '../../../../../global/tables/table-list-layout';
import OECheckbox from '../../../../../global/oe-checkbox/oe-checkbox';
import Text from '../../../../../global/text/text';
import { DateTimeFormatter } from '../../../../../../infrastructure/implementations/date-formatter';
import MeetingArtifactListItemDay from '../../_meeting-artifact-list-item/meeting-artifact-llist-day-item/meeting-artifact-list-day-item';
import { TRequestArtifactsTab } from '../../../../../../api/artifacts.dao';
import { requestArtifactsEmptyListMessage } from '../../../../../../constants/artifacts.constants';
import { MEETINGS_TEXT } from '../../../../../../constants/common-labels.constants';

export interface IRequestReplaysMeetingsTableLayoutProps {
    intl: IntlShape;
    eventTimeZone: string;
    meetingsList: IMeetingDetailsDTO[];
    isAllMeetingsChecked: boolean;
    selectedMeetingIds: Set<number>;
    selectedTab: TRequestArtifactsTab;
    handleArtifactMeetingCheckBox: (meetingId?: number) => void;
}

const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

const RequestReplaysMeetingsTableLayout = ({
    intl,
    isAllMeetingsChecked,
    meetingsList,
    eventTimeZone,
    selectedMeetingIds,
    selectedTab,
    handleArtifactMeetingCheckBox
}: IRequestReplaysMeetingsTableLayoutProps) => {
    const isEmptyList = meetingsList.length === 0;

    const theads: ITheadSort<string>[] = [
        {
            title: (<OECheckbox
                checked={isAllMeetingsChecked}
                onChange={() => handleArtifactMeetingCheckBox()}
                classNames='oe-form-field__checkbox'
                isDisabled={isEmptyList}
            />),
            width: '60px'
        },
        {
            title: intl.formatMessage({
                id: 'oe.reports.dateAndTime',
                description: 'Label text',
                defaultMessage: 'Date & Time'
            }),
            id: 'dataTime',
            width: '170px'
        },
        {
            title: intl.formatMessage({
                id: 'oe.reports.meetingTopic',
                defaultMessage: 'Topic',
                description: 'Label text',
            }),
            id: 'topic',
            width: '180px'
        },
        {
            title: intl.formatMessage({
                id: 'oe.reports.meetingPresenters',
                defaultMessage: 'Presenters',
                description: 'Label text',
            }),
            id: 'presenters',
            width: '150px'
        },
        {
            title: intl.formatMessage({
                id: 'oe.reports.meetingType',
                defaultMessage: 'Meeting Type',
                description: 'Label text',
            }),
            id: 'type',
            width: '150px'
        }
    ];

    const sortOptions: ISortOptions<string> = {
        theads: theads
    };

    return (
        <section>
            <h3>{intl.formatMessage(MEETINGS_TEXT)}</h3>
            <ListLayout
                sortOptions={sortOptions}
            >
                {
                    meetingsList.map(meeting => {
                        const presenters = meeting.presenters.map(p => p.name).join(', ');
                        return (
                            <tr
                                key={meeting.meetingId}
                                onDoubleClick={() => handleArtifactMeetingCheckBox(meeting.meetingId)}
                            >
                                <td className='hoverable'>
                                    <OECheckbox
                                        checked={selectedMeetingIds.has(meeting.meetingId)}
                                        onChange={() => handleArtifactMeetingCheckBox(meeting.meetingId)}
                                        classNames='oe-form-field__checkbox'
                                    />
                                </td>
                                <td className='hoverable' >
                                    <MeetingArtifactListItemDay
                                        eventTimeZone={eventTimeZone}
                                        startDateTime={new Date(meeting.startDateTime)}
                                        dateTimeFormatter={dateTimeFormatter}
                                    />
                                </td>
                                <Text className='hoverable' tag='td' message={meeting.topic} withEllipsis />
                                <Text className='hoverable' tag='td' message={presenters} withEllipsis />
                                <Text className='hoverable' tag='td' message={meeting.type} withEllipsis />

                            </tr>
                        );
                    })
                }

            </ListLayout>
            {
                isEmptyList &&
                <div className='empty-list-message'>
                    { requestArtifactsEmptyListMessage(intl)[selectedTab] }
                </div>
            }
        </section>
    );

};

export default RequestReplaysMeetingsTableLayout;